var Curriculog = Curriculog || {};

Curriculog.ApiSettings = (function ($, _, Backbone, ApiSettings) {


        var ApiSettings = Curriculog.CurriculogCollection.extend({
            url: '/rest/apisetting',

            enabledSetting: function() {
                var enabledSettings = this.where({'name': 'api_enabled'})
                if (enabledSettings.length > 0) {
                    return enabledSettings.pop()
                } else {
                    return undefined
                }
            },
        });

        return ApiSettings;

})($, _, Backbone, Curriculog.ApiSettings || {});
